const fileUpload = function () {
    const fileName = $(this).val().replace(/^.*\\/, "");
    $(this).next('.custom-file-label').addClass('selected').html(fileName);
};

$(document).ready(function () {
    if (!/areas/.test(window.location.toString())) {
        return;
    }

    $(document).on('change', '.custom-file-input', fileUpload);
});
